// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { checkIsCategoryList, checkIsExplicitBlankVote, checkIsInvalidVote, isAcclaimedContest, } from "@sequentech/ui-core";
import { ESlateSelectionStatus, getSlateMembers, getSlateSelectionSummary, } from "./SlateSelection";
var getSelectedCandidateIds = function (contest, selection) {
    var decoded = selection === null || selection === void 0 ? void 0 : selection.find(function (entry) { return entry.contest_id === contest.id; });
    if (!decoded) {
        return [];
    }
    return contest.candidates
        .filter(function (candidate) {
        return !checkIsExplicitBlankVote(candidate) &&
            !checkIsInvalidVote(candidate) &&
            !checkIsCategoryList(candidate);
    })
        .filter(function (candidate) {
        return decoded.choices.some(function (choice) { return choice.id === candidate.id && choice.selected > -1; });
    })
        .map(function (candidate) { return candidate.id; });
};
/**
 * What the review screen says about a ballot with slates, read from the
 * ordinary candidate selections. No slate choice is stored anywhere, so a
 * slate that was chosen and then changed by hand is reported as it is now.
 */
export var getBallotReviewSummary = function (contests, slates, selection) {
    var slateMemberIds = new Set(slates.slates.flatMap(function (slate) {
        return slate.contests.flatMap(function (entry) { return entry.candidates.map(function (candidate) { return candidate.id; }); });
    }));
    var summary = {
        selected: 0,
        seats: 0,
        contests: {},
        slates: [],
        independent: 0,
    };
    for (var _i = 0, contests_1 = contests; _i < contests_1.length; _i++) {
        var contest = contests_1[_i];
        if (isAcclaimedContest(contest)) {
            continue;
        }
        var selectedIds = getSelectedCandidateIds(contest, selection);
        summary.contests[contest.id] = { selected: selectedIds.length, max: contest.max_votes };
        summary.selected += selectedIds.length;
        summary.seats += contest.max_votes;
        summary.independent += selectedIds.filter(function (id) { return !slateMemberIds.has(id); }).length;
    }
    summary.slates = slates.slates
        .map(function (slate) { return ({
        slate: slate,
        summary: getSlateSelectionSummary(getSlateMembers(slate), selection),
    }); })
        .filter(function (line) { return line.summary.status !== ESlateSelectionStatus.NONE; });
    return summary;
};
